package com.parmartechnologies.storage.table.inventory.coupon

import com.parmartechnologies.core.feature.inventory.coupon.model.Coupon
import com.parmartechnologies.storage.collection.DatabaseCollection

import com.parmartechnologies.storage.table.DatabaseTable

class CouponDatabaseTable : DatabaseTable() {
    fun insert(item: Coupon?) {
        item?.let {
            DatabaseCollection().insert(item, Coupon.serializer())
        }
    }

    fun insert(items: List<Coupon>?) {
        items?.let {
            DatabaseCollection().insertAll(items, Coupon.serializer())
        }
    }

    fun retrieve(id: String, callback: (List<Coupon>) -> Unit) {
//        val table = AppDatabase.shared().database?.couponTableQueries
//        val itemsFetched: ArrayList<Coupon> = arrayListOf()
//        scope.launch {
//            val items = table?.retrieve(id)?.awaitAsList()
//            items?.forEach { item ->
//                itemsFetched.add(convert(item))
//            }
//            callback(itemsFetched)
//        }
    }

    fun retrieveAll(id: String,callback: (List<Coupon>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, Coupon.serializer()){
            callback(it)
        }
//        val table = AppDatabase.shared().database?.couponTableQueries
//        val itemsFetched: ArrayList<Coupon> = arrayListOf()
//        scope.launch {
//            val items = table?.retrieveAll()?.awaitAsList()
//            items?.forEach { item ->
//                itemsFetched.add(convert(item))
//            }
//            callback(itemsFetched)
//        }
    }

    fun find(id: String, callback: (Coupon?) -> Unit) {
//        val table = AppDatabase.shared().database?.couponTableQueries
//        var itemsFetched: Coupon? = null
//        scope.launch {
//            val items = table?.find(id)?.awaitAsOneOrNull()
//            items?.let { item ->
//                itemsFetched = convert(item)
//            }
//            callback(itemsFetched)
//        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
//        val table = AppDatabase.shared().database?.couponTableQueries
//        scope.launch {
//            val dateFromDb = table?.LastSyncDate(id)?.awaitAsOneOrNull()
//            callback(dateFromDb?.UpdatedAt)
//        }
    }

//    fun convert(item: CouponTable): Coupon {
//        return Coupon(
//            Id = item._id,
//            CouponID = item.CouponID,
//            UserID = item.UserID,
//            BusinessID = item.BusinessID,
//            IsDeleted = item.IsDeleted,
//            Name = item.Name,
//            Amount = item.Amount,
//            Description = item.Description,
//            CreatedAt = item.CreatedAt,
//            UpdatedAt = item.UpdatedAt,
//        )
//    }
}